import { render, staticRenderFns } from "./tenderList.vue?vue&type=template&id=33c7cb8e&"
import script from "./tenderList.vue?vue&type=script&lang=js&"
export * from "./tenderList.vue?vue&type=script&lang=js&"
import style0 from "./tenderList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports